import { CarSearchController } from 'src/common/controllers/car/search-controller';
export const car = [CarSearchController];